module.exports = __webpack_public_path__ + "img/icon-server-mhs-1.ea1fa748.svg";